import { render, staticRenderFns } from "./treeNew.vue?vue&type=template&id=faf8b4e8&"
import script from "./treeNew.vue?vue&type=script&lang=js&"
export * from "./treeNew.vue?vue&type=script&lang=js&"
import style0 from "./treeNew.vue?vue&type=style&index=0&id=faf8b4e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports